export default "__VITE_ASSET__Bc5F__9E__"